module.exports = __webpack_public_path__ + "img/1.1620e446.png";